<template>
  <ion-page>
    <!--simulate iontoolbar margin/padding stuff-->
    <div class="content-gap"></div>
    <!--:style="{height: isIos ? '100px' : '50px'}"-->

    <ion-progress-bar type="indeterminate" v-if="syncActive && currentProgress == 0"></ion-progress-bar>
    <ion-progress-bar color="primary" v-if="syncActive && currentProgress > 0"
      :value="currentProgress"></ion-progress-bar>

    <small class="ion-padding checking-data" v-if="syncActive && downloadSize === 0">{{
      wordings[currentLanguage].CHECKING_DATA }}</small>
    <small class="ion-padding checking-data" v-if="syncActive && downloadSize && downloadLabel">{{ downloadLabelText }}
      {{ downloadSize }} {{ downloadLabel }} - {{ (currentProgress * 100).toFixed(2) }}%</small>

    <banner direction="horizontal" position="top"></banner>

    <slot></slot>
    <banner direction="vertical" position="bottom"></banner>
    <ion-footer>
      <div class="bottom-navigation-bar menu-color" :class="{ 'bottom-navigation-bar--ios': isIos }">

        <button class="bottom-nav-button" @click="goToProgramme()">
          <ion-icon class="menu-conference" :name="programmeIconName()"></ion-icon>
          <span class="bottom-nav-label menu-conference">Programm</span>
        </button>

        <button class="bottom-nav-button" @click="goToPersons()">
          <ion-icon class="menu-conference" :name="personsIconName()"></ion-icon>
          <span class="bottom-nav-label menu-conference">Nützliches</span>
        </button>
        <button class="bottom-nav-button" @click="goToSearch()">
          <ion-icon class="menu-conference" :name="searchIconName()"></ion-icon>
          <span class="bottom-nav-label menu-conference">Suche</span>
        </button>

        <button class="bottom-nav-button" @click="goToFavorites()">

          <ion-icon class="menu-conference" :name="favoritesIconName()"></ion-icon>
          <span class="bottom-nav-label menu-conference">Mein Kongress</span>
        </button>


        <button class="bottom-nav-button" @click="goToIndustry()">
          <span class="icon-sponsor menu-conference bottom-nav-icon-font"></span>
          <span class="bottom-nav-label menu-conference">Industrie</span>
          <span v-if="unreadTotal > 0" class="bottom-nav-badge">{{ unreadTotal }}</span>
        </button>
      </div>
    </ion-footer>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonFooter,
  IonToolbar,
  IonProgressBar,
  alertController
} from "@ionic/vue";

import { defineComponent } from "vue";
import { mapState, mapGetters } from "vuex";
import { isPlatform, modalController } from '@ionic/vue';
import PdfModal from "@/views/Industry/PdfModal";

const config = require('@/config')
import { addIcons } from "ionicons";
import {
  logoRss,
  chatbubbleOutline,
  chatbubble,
  logInOutline,
  logOutOutline,
  bookmarksOutline,
  bookmark,
  peopleOutline,
  people,
  calendarOutline,
  calendar,
  hammerOutline,
  hammer,
  buildOutline,
  build,
  informationCircle,
  informationCircleOutline,
  search,
  searchOutline
} from "ionicons/icons";

addIcons({
  "logo-rss": logoRss,
  "chatbubble-outline": chatbubbleOutline,
  "chatbubble": chatbubble,
  "log-in-outline": logInOutline,
  "log-out-outline": logOutOutline,
  "bookmark-outline": bookmarksOutline,
  "bookmark": bookmark,
  "people-outline": peopleOutline,
  "people": people,
  "calendar-outline": calendarOutline,
  "calendar": calendar,
  "hammer-outline": hammerOutline,
  "hammer": hammer,
  "build-outline": buildOutline,
  "build": build,
  "ion-information-circle": informationCircle,
  "ion-information-circle-outline": informationCircleOutline,
  "ion-search": search,
  "ion-search-outline": searchOutline
});

export default defineComponent({
  name: "App",
  components: {
    IonPage,
    IonFooter,
    IonToolbar,
    IonProgressBar,
  },
  data() {
    return {

      isDesktop: null,
      isIos: null,
      title: config.full_name,

    }
  },
  mounted() {
  },
  methods: {


    async handleFile() {
      let link = ""
      let viewerLink = link
      console.log(viewerLink)

      this.modal = await modalController
        .create({
          component: PdfModal,
          cssClass: 'pdf-modal',
          componentProps: {
            title: "Privacy policy",
            link: viewerLink
          },
        })
      return this.modal.present();
    },


  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress', 'downloadLabelText']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
  },
  async created() {
    this.isDesktop = isPlatform('desktop');
    this.isIos = isPlatform('ios')
  },

  watch: {
    '$route': {
      immediate: true,
      async handler() {


      }
    }
  },

  methods: {

    // Computed properties for active bottom nav icons
    IndustryIconName() {
      const activePaths = [
        '/app/exhibitions',
        '/app/sponsors',
        '/app/dashboard/e56dc798-f69a-4363-b0c8-c941e0f1d987',
        '/app/dashboard/70f8e667-45af-4415-8ec2-9fd77ea02c16',
        '/app/sessiontypes/da7ad0c0-3ed1-4500-1556-0b0000000008'//INDUSTRY SESSIONS
      ];
      return activePaths.includes(this.$route.path) ? 'build' : 'build-outline';
    },

    favoritesIconName() {
      const activePaths = [
        '/app/favorites/',
      ];
      return activePaths.includes(this.$route.path) ? 'bookmark' : 'bookmark-outline';
    },

    programmeIconName() {
      const activePaths = [
        '/app/sessionlist',
        '/app/persons',
        '/app/sessions/now',
        '/app/sessionList',
        '/app/sessiontypes',
        '/app/sessiontypes/da7ad0c0-3ed1-4500-1582-0b0000000018',
        '/app/dashboard/4d8c69b7-c009-4e36-8253-7a2f184e853a',
        '/app/gridList'
      ];
      return activePaths.includes(this.$route.path) ? 'calendar' : 'calendar-outline';
    },

    personsIconName() {

      const activePaths = [
        '/app/maps',
        '/app/dashboard/9816a029-52e2-4f4d-933a-7ce2d68e7726',
        '/app/generalinfos'
      ];
      return activePaths.includes(this.$route.path) ? 'ion-information-circle' : 'ion-information-circle-outline';
    },
    searchIconName() {

      const activePaths = [
        '/app/search'
      ];
      return activePaths.includes(this.$route.path) ? 'ion-search' : 'ion-search-outline';
    },

    goToSearch() {
      this.$router.push('/app/search');
    },
    goToNews() {
      this.$router.push('/app/posts/');
    },

    goToIndustry() {
      this.$router.push('/app/dashboard/70f8e667-45af-4415-8ec2-9fd77ea02c16');

    },


    goToFavorites() {
      // Dummy link for Events
      this.$router.push('/app/favorites/');
      // You can replace this with: this.$router.push('/app/events/');
    },

    goToProgramme() {
      // Dummy link for Network
      this.$router.push('/app/dashboard/4d8c69b7-c009-4e36-8253-7a2f184e853a');
      // You can replace this with: this.$router.push('/app/network/');
    },

    goToPersons() {
      // Dummy link for Network
      this.$router.push('/app/dashboard/9816a029-52e2-4f4d-933a-7ce2d68e7726');
      // You can replace this with: this.$router.push('/app/network/');
    },

    async chatAlert() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: this.wordings[this.currentLanguage].LOGIN_REQUIRED,
          message: this.wordings[this.currentLanguage].LOG_IN_QUESTION,
          buttons: [
            {
              text: this.wordings[this.currentLanguage].NO_ANSWER,
              role: 'cancel',
              cssClass: 'secondary',
              id: 'cancel-button',
              handler: blah => {
                console.log('Confirm Cancel:', blah)
              },
            },
            {
              text: this.wordings[this.currentLanguage].YES_ANSWER,
              id: 'confirm-button',
              handler: () => {
                this.login()
              },
            },
          ],
        });
      return alert.present();
    },
    async login() {
      console.log("login")
      let self = this
      localStorage.setItem('lastPageBeforeLogin', location.hash);
      //let frontendKey = config.auth_key;
      if (isPlatform('ios') && typeof cordova != 'undefined') {
        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line

        let redirect = (param) => {
          if (param && param.indexOf('token=') != -1) {
            let token = param.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        }

        ref.addEventListener('loaderror', function (event) {
          ref.executeScript({ code: "document.redirectLink = (document.getElementById('redirect').href);" }, ((link) => {
            redirect(link.toString());
          }));
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });

        ref.addEventListener('loadstart', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
          redirect(link.toString());
        }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });


      } else if (isPlatform('android') && typeof cordova != 'undefined') {

        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line
        ref.addEventListener('loaderror', function (event) {

          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
      } else {
        //window.location.href = "https://auth.documedias.com/application/" + config.auth_dev_key
        window.location.href = "https://auth.documedias.com/application/" + (process.env.NODE_ENV == 'production' ? config.auth_key : config.auth_dev_key) + '?logout=true'

      }
    },
  }





});
</script>
<style lang="scss">
.docu-footer {
  background: white !important;
  border-top: 1px solid lightgrey;

  .footer-container {
    width: 100%;
    text-align: center;
    text-decoration: none;
    display: flex;
    justify-content: center; //center
    padding-right: 10px;



    .footer-link {
      color: #274564 !important;
      margin: 1px 5px 2px 5px;
      font-weight: 400;
      font-size: 0.9rem;
      text-decoration: none;
    }
  }

}

ion-progress-bar {
  --background: #ef9a2c;
  --buffer-background: #ef9a2c;
}

ion-footer {
  --background: transparent;
  background: transparent !important;
}

/* Bottom Navigation Bar Styles */
.bottom-navigation-bar {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  height: 62px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 4px;
  padding: 6px 12px calc(6px + env(safe-area-inset-bottom));
  z-index: 1000;
  border-top: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.1);
}

.bottom-navigation-bar--ios {
  height: 102px;
  min-height: 102px;
}

.bottom-nav-button {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  position: relative;
  padding: 6px 4px;
  border-radius: 14px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.bottom-nav-button:hover {
  background: rgba(255, 255, 255, 0.12);
}

.bottom-nav-button:active {
  transform: scale(0.96);
  background: rgba(255, 255, 255, 0.18);
}

.bottom-nav-button ion-icon {
  font-size: clamp(20px, 5vw, 24px);
  margin-bottom: 2px;
}

.bottom-nav-svg {
  width: clamp(20px, 5vw, 24px);
  height: clamp(20px, 5vw, 24px);
  margin-bottom: 2px;
}

.bottom-nav-icon-font {
  font-size: clamp(20px, 5vw, 24px) !important;
  margin-bottom: 2px;
}

.bottom-nav-label {
  font-size: clamp(9px, 2.5vw, 10px);
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-top: 0;
  white-space: nowrap;
  opacity: 0.95;
}

.bottom-nav-badge {
  position: absolute;
  top: 2px;
  right: calc(50% - 20px);
  background: #ff3b30;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: bold;
  min-width: 18px;
  text-align: center;
}

/* Adjust main content to account for bottom bar */
</style>
